module.exports = __webpack_public_path__ + "static/media/Highway-Rider-Extreme.522e798a.png";